import { useGetExamEventParticipatedCoursesQuery } from '@exam-center/graphql';
import { useServerClock } from '@exam-center/server-time';
import { useMemo } from 'react';

import { ExamCourseTimeExtensionDataGrid } from '../../components';
import { type ExamEventSession } from '../../types';

import { mapExamCourseTimeExtensionItems } from './utils';

interface ExamCourseTimeExtensionListProps {
  examEventId: string;
  examStartDate: Date;
  currentSession?: ExamEventSession;
}

export default function ExamCourseTimeExtensionList(
  props: Readonly<ExamCourseTimeExtensionListProps>,
) {
  const { examEventId, examStartDate, currentSession } = props;
  const now = useServerClock();
  const { data: examEventParticipatedCoursesData, loading: isExamEventParticipatedCoursesLoading } =
    useGetExamEventParticipatedCoursesQuery({
      variables: {
        input: {
          examEventId,
        },
      },
      skip: !examEventId,
      fetchPolicy: 'cache-first',
      pollInterval: 10000,
    });

  const examCourseTimeExtensionItems = useMemo(() => {
    const examEventCourses =
      examEventParticipatedCoursesData?.ecGetExamEventParticipatedCourses.examEventCourses ?? [];

    return mapExamCourseTimeExtensionItems(examEventCourses, examStartDate, currentSession, now);
  }, [currentSession, examEventParticipatedCoursesData, examStartDate, now]);

  return (
    <ExamCourseTimeExtensionDataGrid
      rows={examCourseTimeExtensionItems}
      loading={isExamEventParticipatedCoursesLoading}
    />
  );
}
